import * as React from "react";
import { useDispatch, useSelector } from "@teamprevent/admin-redux";

import { Button, Icon } from "semantic-ui-react";

import { AppointmentStatus } from "@teamprevent/common/calendar/models";

import { selectAppointmentByIdSelector } from "../../calendar/selectors";

import { markClinicAppointmentAsArrived } from "../../calendar/clinics/actions";

export interface IProps {
    appointmentId: string;
}

export const CheckInButton: React.FC<IProps> = (props: IProps) => {
    const dispatch = useDispatch();
    const [markAsCheckedIn, setMarkAsCheckedIn] = React.useState<boolean>(false);

    const appointment = useSelector(selectAppointmentByIdSelector(props.appointmentId));

    const OnCheckInButtonClick = React.useCallback((event: React.MouseEvent<HTMLButtonElement>) => {
        event.preventDefault();
        dispatch(markClinicAppointmentAsArrived(props.appointmentId));
        setMarkAsCheckedIn(true);
    }, []);

    return (
        <>
            { !markAsCheckedIn && appointment?.status === AppointmentStatus.Pending &&
                <Button icon onClick={OnCheckInButtonClick}>
                    <Icon name='sign-in' />
                </Button>
            }
        </>
    );
};
